/*
 * @Date: 2023-04-21 09:29:23
 * @LastEditors: 雷安刚 15108293674@163.com
 * @LastEditTime: 2023-04-21 09:42:28
 * @FilePath: \pig-merchant-accountCenter-web\src\utils\resize.js
 */
import Vue from "vue";
const resize = { // 指令的名称
  bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
    let width = '', height = '';
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
}
Vue.directive('resize', resize)